<template>
  <svg :class="classes">
    <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="id"></use>
  </svg>
</template>


<script>
export default {
  props: {
    name: '',
    className: {
      default: 'component-symbol',
      type: String
    }
  },
  computed: {
    id () {
      return '#' + this.name
    },
    classes () {
      return `${this.className} ${this.className}-${this.name}`
    }
  }
}
</script>


<style lang="scss">
.component-symbol {
  fill: currentcolor;
}
</style>


// WEBPACK FOOTER //
// Symbol.vue?0fc207da